import React from 'react';
import LotsLayout from "../LotsLayout";
import MaxWidthDiv from "../../../../../ui/MaxWitdthDiv";
import {
    TanneryProductionProvider
} from "../../../../../../utils/contexts/tannery_production/tannery_production-context";
import {
    TanneryRawMaterialProvider
} from "../../../../../../utils/contexts/tannery_raw_material/tannery_raw_material-context";
import TotalsByPeopleTable from "./TotalsByPeopleTable";


const TotalsByPeopleScreen = () => {


    return (
        <>
            <LotsLayout>
                <MaxWidthDiv maxWidth='1980px'>
                    <TanneryProductionProvider>
                        <TanneryRawMaterialProvider>
                            {/*<LotsList/>*/}
                            <TotalsByPeopleTable/>
                        </TanneryRawMaterialProvider>
                    </TanneryProductionProvider>

                </MaxWidthDiv>
            </LotsLayout>


        </>
    );
};

export default TotalsByPeopleScreen;
